import type { Color } from "../types";

/**
 * Blends two colors by given balance. Balance should be number between 0 and 1.
 * Balance is weight of first color. Second color weight is (1 - balance).
 *
 * @param color1
 * @param color2
 * @param balance
 */
export function blendColors(
  color1: Color,
  color2: Color,
  balance = 0.5
): Color {
  const weight2 = 1 - balance;
  const result = [0, 0, 0, 0];

  for (let i = 0; i < 4; i++) {
    result[i] = Math.round(color1[i] * balance + color2[i] * weight2);
  }

  return result as unknown as Color;
}
